module.exports = __webpack_public_path__ + "assets/img/b0.9d2881ba.png";